import antdVi from 'antd/lib/locale-provider/vi_VN';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/vi';

import viMessages from '../locales/vi_VN.json';

const viLang = {
  messages: {
    ...viMessages,
  },
  antd: antdVi,
  locale: 'vi-VN',
};
export default viLang;
